<template>
    <div v-if="user">
        <va-loading v-if="loading" size="md" :center="true" />
        <div :class="{dimmed: loading}">
            <va-row v-if="user.get('roles').includes('guest') == false" :gutter="32"
                style="padding-bottom: 70px; margin-top: 30px">
                <va-column :lg="6" :md="6" :sm="12" :xs="12">
                    <h4 class="approvalHead" :class="{rtlHead: getSystemLanguage != 'english'}"
                        style="margin-left:14px; border-bottom:2px solid #07f7 !important;">
                        <span class="headContent">{{ _("Activities")}}</span>
                    </h4>

                    <div class="activity_main_wrapper">
                        <activities v-if="user.get('type') != 'guest'" />
                    </div>
                </va-column>
                <va-column :lg="6" :md="6" :sm="12" :xs="12">
                    <h4 class="approvalHead" :class="{rtlHead: getSystemLanguage != 'english'}">
                        <span class="headContent">{{ _("Needs Approval")}}</span>
                    </h4>
                    <div>
                        <va-table hover fullWidth class="datatable approvalTable">
                            <table :dir="getDirectionStatus">
                                <thead>
                                    <tr>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Name') }}</th>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Category') }}
                                        </th>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Created By')
                                            }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="allSectionObjectsThatNeedsMyApprovalCount != 0 && obj.get('category')!=null && obj.get('createdBy')!=null"
                                        v-for="obj in allSectionObjectsThatNeedsMyApproval" style="cursor: pointer">
                                        <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                            <a style="cursor:pointer"
                                                @click="navigate({name: section + 'Preview', params: {id: obj.id, category: obj.get('category').get('slug'), scope: getObjectScope(obj)}}   )">{{
                                                g_getLabel(obj) }}</a>
                                        </td>
                                        <td>{{ _(g_getLabel(obj.get('category'))) }}</td>
                                        <td>{{ obj.get('createdBy').get('name') }}</td>
                                    </tr>

                                    <tr v-if="allSectionObjectsThatNeedsMyApprovalCount == 0">
                                        <td :class="{rtlTd: getSystemLanguage != 'english'}" :colspan="3"
                                            style="text-align: center">
                                            {{ _("No " + section + 's') }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </va-table>
                    </div>
                    <!-- <div v-else class="deadCenter">
                        <p>{{ _("No " + section + 's') }}</p>
                    </div> -->
                </va-column>

            </va-row>

            <va-row v-else>
                <va-column :sm="12" :xs="12" :lg="12" :md="12">
                    <div style="margin-top: 5%">
                        <data-list />
                    </div>
                </va-column>
            </va-row>
        </div>
    </div>
</template>

<script>
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import Activities from "./Activities.vue"
    import DataList from "./DataList.vue"
    export default {

        components: {
            Activities,
            DataList
        },

        data() {
            return {
                allSharedSurveys: [],
                parentRoute: '',
                allSubmissions: [],
                fields: [],
                newCategory: '',
                newCategoryPashto: '',
                newCategoryDari: '',
                categoryScope: null,
                allSectionObjectsThatNeedsMyApproval: [],
                allSectionObjectsThatNeedsMyApprovalCount: null,
                loading: false,


                // new
                activities: [],
                section: ''
            }
        },
        computed: {
            ...mapGetters(['getCurrentDepartment', 'user', 'getGlobalCategories', 'getSavedFilters', 'getDepartments',
                'getSelectedDashboardItem', 'getSystemLanguage', 'getDirectionStatus',
            ]),

        },
        methods: {
            ...mapActions(['sendNewNotification', 'fetchDepartmentLocalCategories', 'fetchDepartmentGlobalCategories',
                'setGlobalCategories', 'setDepartments', 'setLoading'
            ]),

            getObjectScope(obj) {
                var scope = '';
                if (obj != null) {
                    if (obj.get('department') != null) {
                        scope = obj.get('department').get('slug')
                    } else {
                        scope = 'global';
                    }
                }
                return scope;
            },

            navigate(route) {
                this.$router.push(route);
            },

            async fetchSectionObjectsThatNeedsMyApproval(pageNumber) {
                let q
                if (this.section == 'article') q = new Parse.Query('Article')
                if (this.section == 'file') q = new Parse.Query('File')
                if (this.section == 'map') q = new Parse.Query('Map')
                q.select("status", "label_english", "label_pashto", "label_dari", "createdBy", "category", "approvers", "department");
                q.include('createdBy')
                q.include('department')
                q.include('category')
                q.equalTo('status', 'pending')
                q.equalTo('approvers', this.user)
                let result = await q.find()
                this.allSectionObjectsThatNeedsMyApproval = result
            },

            async fetchSectionObjectsThatNeedsMyApprovalCount() {
                let q
                if (this.section == 'article') q = new Parse.Query('Article')
                if (this.section == 'file') q = new Parse.Query('File')
                if (this.section == 'map') q = new Parse.Query('Map')
                q.equalTo('status', 'pending')
                q.equalTo('approvers', this.user)
                let result = await q.count()
                this.allSectionObjectsThatNeedsMyApprovalCount = result
            }
        },

        async mounted() {
            this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
            this.$store.commit("setLoading", true);
            await this.fetchSectionObjectsThatNeedsMyApprovalCount()
            await this.fetchSectionObjectsThatNeedsMyApproval(1)
            this.$store.commit("setLoading", false);
        }
    }
</script>

<style>
    .approvalHead .headContent {
        color: #026a !important;
    }

    .approvalHead {
        color: #026a !important;
        /* font-size: 0.8em; */
        font-weight: normal;
        text-transform: uppercase;
        background: #0bf1;
        border: 2px solid #07f7 !important;
        border-bottom: none !important;
        margin-bottom: 0px !important;
        padding: 1px 12px;
        display: inline-block;
    }

    .approvalTable {
        margin-top: 0px !important;
    }
</style>